import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizHtmlEditor from "@/components/quiz/QuizHtmlEditor.vue";
import axios from "axios";
import WElmessage from "@/components/wrappers/w-elmessage.vue";
import { Events } from "@/events/events";
import AxiosUtils from "@/util/axiosUtils";
let SuccessChapterView = class SuccessChapterView extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "chapterId", void 0);
    _defineProperty(this, "successChapterData", void 0);
    _defineProperty(this, "realtimeHtmlSuccess", '');
    _defineProperty(this, "realtimeHtmlFail", '');
  }
  mounted() {
    this.getSuccessChapterData();
  }
  get greaterRateMsgEditorId() {
    return `successChapter-onSuccess-msg-editor-${this.chapterId}`;
  }
  get lesserRateMsgEditorId() {
    return `successChapter-onFail-msg-editor-${this.chapterId}`;
  }
  get rateMsgEditorConfig() {
    return {
      placeholder: this.$t('chapter.successView.rateMsgPlaceholder'),
      height: '228px'
    };
  }
  getSuccessChapterData() {
    axios.get(`/api/v2/chapters/${this.chapterId}/contenu-reussite-for-editing`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      this.successChapterData = response.data;
      this.realtimeHtmlSuccess = this.successChapterData.htmlSuccess;
      this.realtimeHtmlFail = this.successChapterData.htmlFail;
    }, error => {
      AxiosUtils.displayError(error, this.$t('errors.default'));
    });
  }
  onRateChange(rate) {
    if (rate < 0 || rate > 100) {
      WElmessage.showErrorMessage(this.$t('chapter.successView.error.invalidRate'));
      return;
    }
    this.saveSuccessChapterContent({
      rate
    }, this.$t('chapter.successView.success.rate'));
  }
  onGreaterRateMsgBlur(msg) {
    if (msg.trim() !== this.realtimeHtmlSuccess.trim()) {
      this.realtimeHtmlSuccess = msg.trim();
      this.saveSuccessChapterContent({
        htmlSuccess: this.realtimeHtmlSuccess
      }, this.$t('chapter.successView.success.greaterRateMsg'));
    }
  }
  onLesserRateMsgBlur(msg) {
    if (msg.trim() !== this.realtimeHtmlFail.trim()) {
      this.realtimeHtmlFail = msg.trim();
      this.saveSuccessChapterContent({
        htmlFail: this.realtimeHtmlFail
      }, this.$t('chapter.successView.success.lesserRateMsg'));
    }
  }
  saveSuccessChapterContent(data, successfulMsg) {
    axios.patch(`/api/v2/chapters/${this.chapterId}/contenu-reussite`, {
      contenuReussiteDataJson: JSON.stringify(data)
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(() => {
      WElmessage.showSuccessMessage(successfulMsg);
      trig(Events.RAFRAICHIR_PLAN_CHAPITRE, this.chapterId);
    }, error => {
      AxiosUtils.displayError(error, this.$t('errors.default'));
    });
  }
};
__decorate([Prop({
  required: true
})], SuccessChapterView.prototype, "chapterId", void 0);
SuccessChapterView = __decorate([Component({
  components: {
    QuizHtmlEditor,
    WInput
  }
})], SuccessChapterView);
export default SuccessChapterView;